exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deliverable-block .top-row[data-v-382930a0]{background-color:var(--wf-primary);color:var(--wf-secondary)}.drag-handle[data-v-382930a0]{width:2rem}", ""]);

// exports
